import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@querodelivery/uni-react';
import { colors } from '@/Themes/Colors';
import style from './deactivate-post-paid-modal.module.scss';
import { usePutPostPaid } from '@/_features/places/api/put-post-paid';
import { queryClient } from '@/_config/lib/react-query/query-client';
import { GET_PLACE_ID } from '@/_features/places/api/constants';
import { Modal } from '@/_components/modal/modal';

interface DeactivatePostPaidModalProps {
  open: boolean;
  onClose: () => void;
  placeId: string;
}

export const DeactivatePostPaidModal = ({
  open,
  onClose,
  placeId,
}: DeactivatePostPaidModalProps) => {
  const { mutate: updatePostPaid, isLoading } = usePutPostPaid();

  const handleConfirm = () => {
    updatePostPaid(
      {
        placeId,
        statusPostPaid: 'INACTIVE',
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([GET_PLACE_ID, { placeId }]);
          onClose();
        },
      },
    );
  };
  return (
    <Modal
      bodyClassName={style.bodyContainer}
      noBorder
      onClose={onClose}
      open={open}
      width={500}
    >
      <FontAwesomeIcon icon={faBell} color={colors.gray60} size="4x" />
      <span className={style.title}>
        Você está desativando o pós pago a este parceiro.
      </span>
      <span className={style.description}>
        Ao confirmar este parceiro não terá mais o beneficio do pós pago, mas
        poderá utilizar o pré pago.
      </span>
      <div className={style.buttons}>
        <Button
          className={style.button}
          onClick={onClose}
          disabled={isLoading}
          variant="outline"
          size="lg"
        >
          Cancelar
        </Button>
        <Button
          className={style.button}
          onClick={handleConfirm}
          disabled={isLoading}
          variant="primary"
          size="lg"
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};
